import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const UPDATE_QUERY = print(gql`
  mutation UpdatePartnerCompany($data: UpdatePartnerCompanyInput!) {
    updatePartnerCompany(data: $data) {
      id
    }
  }
`);

export interface UpdateGql {
  updatePartnerCompany: {
    id: number;
  };
}
